export const GlobalAddress = {
    address1 : "Saravanampatty",
    city:"Coimbatore",
    state:"Tamil Nadu",
    pincode:"641035",
    phone:"9876543210"

}